import React from 'react';
import ColorTag from '../ColorTag/ColorTag';

interface ColorTagDeletedProps {}

const ColorTagDeleted: React.FC<ColorTagDeletedProps> = props => {
  return <ColorTag className="ColorTagDeleted" color="median">Deleted</ColorTag>
}

export default ColorTagDeleted;